export interface ManpowerSettingStateInterface {
  payload: any;
}

export const initManpowerSettingsState: ManpowerSettingStateInterface = {
  payload: [],
};
